export enum ID_TYPE {
  FACILITY_ID = 'fa',
  STORE_CODE = 'sc',
}
